// extracted by mini-css-extract-plugin
module.exports = {"offerText":"CountDown_offerText__1n7ay"};